import script from "./AddSchoolYear.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSchoolYear.vue?vue&type=script&setup=true&lang=js"

import "./AddSchoolYear.vue?vue&type=style&index=0&id=60888825&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60888825"]])

export default __exports__